import { openDB } from 'idb'

const DB_NAME = 'bazaart-sw'
const STORE_NAME = 'keyval'

const dbPromise = openDB(DB_NAME, 1, {
  upgrade(db) {
    db.createObjectStore(STORE_NAME)
  },
})

export async function idbGet<T>(key: string): Promise<T | undefined> {
  return (await dbPromise).get(STORE_NAME, key)
}

export async function idbSet<T>(key: string, value: T): Promise<void> {
  await (await dbPromise).put(STORE_NAME, value, key)
}

export async function idbRemove(key: string): Promise<void> {
  await (await dbPromise).delete(STORE_NAME, key)
}
